/**
 * Второй сокет: publication v5. Статус основной ленты не трогаем — обрыв
 * пятёрки не должен писать «связь потеряна» над живыми 0/1/2.
 */

import { alignFork } from '../lib/align';
import type { Fork } from '../lib/protocol';
import { FeedClient } from '../ws/client';
import { markLenta5 } from '../lib/lenta5';

const PROTO = 2;
const SIGNALS_MS = 4_000;

let client: FeedClient | null = null;
let forks = new Map<string, Fork>();
let publish: ((next: Map<string, Fork>) => void) | null = null;

export function lenta5Snapshot(): Map<string, Fork> {
  return forks;
}

export function onLenta5Publish(fn: (next: Map<string, Fork>) => void): void {
  publish = fn;
}

function tagged(raw: Map<string, Fork>): Map<string, Fork> {
  const next = new Map<string, Fork>();
  for (const fork of raw.values()) {
    const one = markLenta5(fork);
    next.set(one.id, one);
  }
  return next;
}

function lenta5SocketUrl(location: { protocol: string; host: string }): string {
  const scheme = location.protocol === 'https:' ? 'wss' : 'ws';
  return `${scheme}://${location.host}/v5/v1/lanes/live/ws`;
}

export function startLenta5Feed(): void {
  if (client !== null) return;
  client = new FeedClient(lenta5SocketUrl(location), PROTO, {
    onStatus: () => {
      /* пип шапки держит основной сокет */
    },
    onState: (incoming) => {
      forks = tagged(incoming);
      publish?.(forks);
    },
    onGone: (id, why) => {
      const marked = markLenta5({ id, why });
      forks.delete(marked.id);
      publish?.(forks);
    },
    onProtocolMismatch: () => {
      /* proto 2 пятёрки не перезагружает /app */
    },
  });
  client.connect();
  void hydrateLenta5();
}

async function hydrateLenta5(): Promise<void> {
  try {
    const answer = await fetch('/v5/v1/lanes/live/signals', {
      credentials: 'same-origin',
      signal: AbortSignal.timeout(SIGNALS_MS),
    });
    if (!answer.ok || forks.size > 0) return;
    const body = (await answer.json()) as { forks?: Fork[] };
    if (!Array.isArray(body.forks) || body.forks.length === 0) return;
    const now = Date.now();
    const next = new Map<string, Fork>();
    for (const fork of body.forks) {
      const one = markLenta5({ ...alignFork(fork), at: now });
      next.set(one.id, one);
    }
    forks = next;
    publish?.(forks);
  } catch {
    /* 0/1/2 живут сами */
  }
}

export function stopLenta5Feed(): void {
  client?.close();
  client = null;
  forks = new Map();
  publish = null;
}
